import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';

type ChatStartConfirmDialogProps = {
  onConfirm: () => void | Promise<void>;
};

export const ChatStartConfirmDialog = ({
  onConfirm,
}: ChatStartConfirmDialogProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.CHAT);

  return (
    <Dialog
      description={t('Chat.StartConfirm.body')}
      secondaryAction={{
        label: t('Chat.StartConfirm.cancel'),
        variant: 'terciary',
      }}
      primaryAction={{
        label: t('Chat.StartConfirm.continue'),
        action: () => void onConfirm(),
      }}
      open
      hideClose
    />
  );
};
